import { useCallback, useState } from 'react'
import { isEmpty, reduce, toPairs } from 'ramda'

import { parentControls } from './ParentControls'
import { bankDetailsControls } from './BankControls'


export const getControlValues = (form: HTMLFormElement) => {
  const formData = new FormData(form)

  return {
    parentAddress: formData.get(parentControls.Address) as string,
    parentPhone: formData.get(parentControls.Phone) as string,
    bik: formData.get(bankDetailsControls.Bik) as string,
    checkingAccount: formData.get(bankDetailsControls.CheckingAccount) as string,
  }
}

export type ControlValues = ReturnType<typeof getControlValues>

export function useErrors(onErrors: () => void) {
  const [errors, setErrors] = useState<Partial<ControlValues>>({})

  const validateControlValues = useCallback((values: ControlValues) => {
    const pairs = toPairs(values)
    const currentErrors = reduce((acc, [key, val]) => {
      if (!val) {
        acc[key] = 'Заполните обязательное поле'
      }
      return acc
    }, {} as Record<string, string>, pairs)

    const hasErrors = !isEmpty(currentErrors)

    if (hasErrors) {
      setErrors(currentErrors)
      onErrors()
      return false
    }
    return true
  }, [onErrors])

  const resetErrors = useCallback(() => {
    setErrors({})
  }, [])

  return {
    errors,
    validateControlValues,
    resetErrors,
  }
}
